var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAltaModulo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.53 491.53",
    style: {
      enableBackground: "new 0 0 491.53 491.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 122.885,
    style: {
      fill: "#E1E6E9"
    },
    width: 491.52,
    height: 122.88
  }), /*#__PURE__*/React.createElement("rect", {
    y: 245.765,
    style: {
      fill: "#FFFFFF"
    },
    width: 491.52,
    height: 122.88
  }), /*#__PURE__*/React.createElement("rect", {
    y: 368.645,
    style: {
      fill: "#EBF0F3"
    },
    width: 491.52,
    height: 122.88
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.005,
    style: {
      fill: "#64798A"
    },
    width: 355.379,
    height: 122.88
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.379,
    y: 0.005,
    style: {
      fill: "#27A2DB"
    },
    width: 136.151,
    height: 122.88
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M462.18,93.856l-26.049-26.049c8.06-11.124,7.172-26.76-2.838-36.779 c-11.11-11.092-29.167-11.074-40.259,0c-11.101,11.101-11.101,29.158,0,40.259c5.551,5.542,12.838,8.317,20.125,8.317 c5.874,0,11.693-1.887,16.655-5.479l26.049,26.049L462.18,93.856z M399.352,64.969c-7.619-7.619-7.619-20.003,0-27.622 c3.805-3.805,8.806-5.708,13.806-5.708c5.01,0,10.011,1.903,13.815,5.708c7.611,7.619,7.611,20.011,0,27.622 C419.373,72.578,406.971,72.587,399.352,64.969z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCD462"
    },
    cx: 216.32,
    cy: 61.445,
    r: 26.516
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#44C4A1"
    },
    cx: 294.451,
    cy: 61.445,
    r: 26.516
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M103.505,225.245H28.577c-1.909,0-3.457-1.548-3.457-3.456v-74.928c0-1.909,1.548-3.457,3.457-3.457 h74.929c1.909,0,3.457,1.548,3.457,3.457v74.928C106.962,223.698,105.414,225.245,103.505,225.245z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 153.088,
    style: {
      fill: "#E56353"
    },
    width: 150.564,
    height: 17.874
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 197.688,
    style: {
      fill: "#D5D6DB"
    },
    width: 322.166,
    height: 17.874
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27A2DB"
    },
    d: "M103.505,348.125H28.577c-1.909,0-3.457-1.548-3.457-3.457V269.74c0-1.909,1.548-3.457,3.457-3.457 h74.929c1.909,0,3.457,1.548,3.457,3.457v74.929C106.962,346.578,105.414,348.125,103.505,348.125z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 275.968,
    style: {
      fill: "#64798A"
    },
    width: 150.564,
    height: 17.874
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 320.568,
    style: {
      fill: "#D5D6DB"
    },
    width: 322.166,
    height: 17.874
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M103.505,471.005H28.577c-1.909,0-3.457-1.548-3.457-3.457v-74.928c0-1.909,1.548-3.457,3.457-3.457 h74.929c1.909,0,3.457,1.548,3.457,3.457v74.928C106.962,469.458,105.414,471.005,103.505,471.005z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 398.848,
    style: {
      fill: "#27A2DB"
    },
    width: 150.564,
    height: 17.874
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.012,
    y: 443.448,
    style: {
      fill: "#D5D6DB"
    },
    width: 322.166,
    height: 17.874
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAltaModulo);
export default __webpack_public_path__ + "static/media/menu_alta_modulo.cad561f8be4823472756fdfb425c495e.svg";
export { ForwardRef as ReactComponent };